import React from "react"
import { useAppCtx } from "lib/state"
import { appTools, cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider";
import { useRenderStyling } from '../../../hooks/useRenderStyling';

export default function SummaryTableRender(){

  const { getApiFeedData, getElementConfig, formatter, parseApiData }:any = useTemplatePreviewCtx()
  const config = getElementConfig("policies")

  const config_data = [
    { label: "MID", path: "merchant.AccountNumber", render: (value:any) => value },
    { label: "Merchant Name", path: "merchant.DBA", render: (value:any) => value },
    { label: "Case ID", path: "rp.Chargeback.ProcessorCaseId", render: (value:any) => value },
    { label: "Transaction ID", path: "rp.Chargeback.ExternalChargebackId", render: (value:any) => value },
    { label: "ARN/REF", path: "rp.Chargeback.ARN", render: (value:any) => value },
    { label: "Chargeback Date", path: "rp.Chargeback.DisputeDate", render: (value:any) => formatter.date(value, "MMM DD, YYYY") },
    { label: "Chargeback Amount", path: "rp.Chargeback.Amount", render: (value:any) => formatter.currency(value, getApiFeedData("rp.Chargeback.Currency") ) },
    { label: "BIN", path: "rp.Chargeback.BIN", render: (value:any) => value },
    { label: "Last Four", path: "rp.Chargeback.LastFour", render: (value:any) => value },
    { label: "Transaction Date", path: "rp.RepresentmentTransactionInfo.TransactionDate", render: (value:any) => formatter.date(value, "MMM DD, YYYY") },
    { label: "Transaction Amount", path: "rp.RepresentmentTransactionInfo.Amount", render: (value:any) => formatter.currency(value, getApiFeedData("rp.Chargeback.Currency") ) },
  ]

  const outerStyling = useRenderStyling("w-full flex flex-col mt-4", "styleObj")
  const innerStyling = useRenderStyling("w-full flex flex-col justify-start items-start", "styleObj")
  const rowStyling = useRenderStyling("w-full flex items-center pt-0.5 pb-0.5", "styleObj")
  const labelStyling = useRenderStyling("w-44 font-semibold text-right pr-4 text-neutral-900", "styleObj")
  const dataStyling = useRenderStyling("text-neutral-900", "styleObj")


  return (
    <div id="mm-summary-table" {...outerStyling}>
      <div {...innerStyling}>
        { config_data.map( (item:any) => (
          <div key={item.label} {...rowStyling}>
            <div {...labelStyling}>{item.label}</div>
            <div {...dataStyling}>{ parseApiData(`[[${item.path}]]`)?.result || "" }</div>
          </div>
        ))}
      </div>
    </div>
  )
}